<template>
  <div>TrangXemNhomChucVu</div>
</template>

<script>
export default {
  name: "TrangXemNhomChucVu"
};
</script>


